function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "user-placeholder-clip"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  fill: "currentColor",
  d: "m939.015,824.99999l-777,0c-0.617,-65.533 20.657,-122.113 33.67,-177.414c5.133,-21.815 19.474,-47.729 34.965,-59.569c20.65,-15.786 90.75,-38.466 121.73,-47.915c48.021,-14.647 73.864,-41.937 112.665,-64.749c4.964,-21.842 4.111,-35.936 -2.045,-51.342c-4.316,-15.107 -15.654,-29.381 -19.97,-44.487c-9.626,-14.977 -26.511,-32.861 -31.08,-51.8c-4.769,-19.766 -4.53,-51 -1.3,-71.224q1.941,-25.9 3.885,-51.8c13.329,-56.314 52.882,-89.456 104.895,-107.484c14.326,-4.966 38.632,-12.34 60.865,-7.77c13.872,2.852 20.824,13.329 32.375,18.13c40.888,17 75.628,16.517 89.355,59.57q2.589,46.614 5.18,93.239c5.034,24.58 10.737,40.08 0,67.339c-11.6,29.449 -65.033,99.272 -44.03,143.744c5.635,11.933 16.816,13.784 25.9,22.015c13.234,11.992 22.62,31.587 38.85,40.144c48.31,25.474 109.822,29.427 151.515,60.865c30.617,23.082 57.76,171.572 59.575,230.508z"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "user-placeholder-gradient",
  x1: "0%",
  y1: "0%",
  x2: "0%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "white",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 1
})), /*#__PURE__*/React.createElement("mask", {
  id: "user-placeholder-mask"
}, /*#__PURE__*/React.createElement("rect", {
  x: 0,
  y: 0,
  height: 205,
  width: "100%",
  fill: "url(#user-placeholder-gradient)"
})));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  fill: "currentColor",
  d: "m939.015,824.99999l-777,0c-0.617,-65.533 20.657,-122.113 33.67,-177.414c5.133,-21.815 19.474,-47.729 34.965,-59.569c20.65,-15.786 90.75,-38.466 121.73,-47.915c48.021,-14.647 73.864,-41.937 112.665,-64.749c4.964,-21.842 4.111,-35.936 -2.045,-51.342c-4.316,-15.107 -15.654,-29.381 -19.97,-44.487c-9.626,-14.977 -26.511,-32.861 -31.08,-51.8c-4.769,-19.766 -4.53,-51 -1.3,-71.224q1.941,-25.9 3.885,-51.8c13.329,-56.314 52.882,-89.456 104.895,-107.484c14.326,-4.966 38.632,-12.34 60.865,-7.77c13.872,2.852 20.824,13.329 32.375,18.13c40.888,17 75.628,16.517 89.355,59.57q2.589,46.614 5.18,93.239c5.034,24.58 10.737,40.08 0,67.339c-11.6,29.449 -65.033,99.272 -44.03,143.744c5.635,11.933 16.816,13.784 25.9,22.015c13.234,11.992 22.62,31.587 38.85,40.144c48.31,25.474 109.822,29.427 151.515,60.865c30.617,23.082 57.76,171.572 59.575,230.508z"
});

var SvgUserPlaceholder = function SvgUserPlaceholder(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1100,
    height: 825,
    viewBox: "0 0 1100 825",
    enableBackground: "new 0 0 1100 820",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#user-placeholder-clip)"
  }, _ref3, /*#__PURE__*/React.createElement("rect", {
    mask: "url(#user-placeholder-mask)",
    className: "loader",
    width: "100%",
    height: 205,
    y: 0,
    x: 0,
    fillOpacity: "null",
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "red",
    style: {
      display: "none"
    }
  })));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUserPlaceholder, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/user_placeholder.72dd2c9c.svg";
export { ForwardRef as ReactComponent };